import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Renderer2,
  QueryList,
  ViewChildren,
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonService } from "src/app/shared/services/common.service";
import { FormBuilder, FormGroup } from "@angular/forms";
import { filter } from "rxjs";
import { MatMenu } from "@angular/material/menu";
import { JsignalService } from "src/app/shared/services/jsignal.service";

interface FieldConfig {
  key: string;
  label: string;
  type: "text" | "select" | "multiselect" | "date";
  options?: string[];
  lookupType?: string;
}
interface ActiveFilter {
  key: string;
  label: string;
  value: any;
}
interface NavGroup {
  label: string;
  icon: string;
  items: typeof this.topNavItems; // same type as topNavItems elements
}
interface Product {
  name?: string;
  id?:any;
}
interface ProductMeta {
  id?: string;
  status?: string;
  dibd?: string | null; // DIBD
  ibd?: string | null; // IBD
  safetyTitle?: string;
  safetyStrategyLink?: string;
  producttype?: string;
}

@Component({
    selector: "app-jsignal-product",
    templateUrl: "./jsignal-product.component.html",
    styleUrls: ["./jsignal-product.component.scss"],
    standalone: false
})
export class JsignalProductComponent implements OnInit, AfterViewInit {
  productLink: string = "https://example.com";

  backgroundColorScreen = "";
  backgroundColorButton = "";
  currentSection!: string;
  selectedTabIndex = 0;
  showJsignalPage = false;
  selectedProduct: any = null; // instead of index

  @ViewChild("toolbarScroll") toolbarScroll!: ElementRef;
  @ViewChildren("childMenu", { read: MatMenu }) childMenus!: QueryList<MatMenu>;

  menuMap: { [key: string]: MatMenu } = {};

  showLeftArrow = false;
  showRightArrow = true;

  @ViewChild("topToolbarScroll", { static: true })
  topToolbarScroll!: ElementRef;
  showTopLeftArrow = false;
  showTopRightArrow = true;
selectedTopNavItem: any;
  toolbarItems = [
    {
      icon: "info",
      label: "Product Info",
      section: "product-info",
      isRoute: false,
    },
    {
      icon: "rate_review",
      label: "Review Activities",
      section: "review-info",
      isRoute: false,
    },
    {
      icon: "notification_important",
      label: "Alerts",
      section: "alerts-info",
      isRoute: false,
    },
    {
      icon: "insights",
      label: "Signals",
      section: "signals-info",
      isRoute: false,
    },
    {
      icon: "assignment_turned_in",
      label: "Actions",
      section: "actions-info",
      isRoute: false,
    },
    {
      icon: "help_center",
      label: "HA Request",
      section: "ha-request-info",
      isRoute: false,
    },
    {
      icon: "event",
      label: "Meetings",
      section: "meetings-info",
      isRoute: false,
    },
    {
      icon: "task_alt",
      label: "My Tasks",
      section: "my-tasks-info",
      isRoute: false,
    },
    {
      icon: "update",
      label: "Key Changes",
      section: "key-changes-info",
      isRoute: false,
    },
  ];
  topNavItems = [
    { label: "Home", icon: "home", section: "Home", isRoute: false,
      subToolbarItems:[
    {
      icon: "info",
      label: "Product Info",
      section: "product-info",
      isRoute: false,
    },
    {
      icon: "rate_review",
      label: "Review Activities",
      section: "review-info",
      isRoute: false,
    },
    {
      icon: "notification_important",
      label: "Alerts",
      section: "alerts-info",
      isRoute: false,
    },
    {
      icon: "insights",
      label: "Signals",
      section: "signals-info",
      isRoute: false,
    },
    {
      icon: "assignment_turned_in",
      label: "Actions",
      section: "actions-info",
      isRoute: false,
    },
    {
      icon: "help_center",
      label: "HA Request",
      section: "ha-request-info",
      isRoute: false,
    },
    {
      icon: "event",
      label: "Meetings",
      section: "meetings-info",
      isRoute: false,
    },
    {
      icon: "task_alt",
      label: "My Tasks",
      section: "my-tasks-info",
      isRoute: false,
    },
    {
      icon: "update",
      label: "Key Changes",
      section: "key-changes-info",
      isRoute: false,
    },
  ]
     },
    {
      label: "Configuration",
      icon: "settings",
      section: "Configuration-info",
      isRoute: false,
      subToolbarItems: [
        {
          label: "Product Safety Strategy Template",
          icon: "description",
          section: "Product Safety Strategy Template",
          isRoute: false,
        },
        {
          label: "Product Safety Strategy",
          icon: "policy",
          section: "Product Safety Strategy",
          isRoute: false,
        },
        {
          label: "Review & Approve",
          icon: "fact_check",
          section: "Review & Approve",
          isRoute: false,
        },
        {
          label: "Review Activities Config",
          icon: "rate_review",
          section: "ReviewConfig",
          isRoute: false,
        },
        {
          label: "Alert Config",
          icon: "notification_important",
          section: "AlertConfig",
          isRoute: false,
        },
        {
          label: "Signal Config",
          icon: "analytics",
          section: "SignalConfig",
          isRoute: false,
        },
        {
          label: "HA Config",
          icon: "health_and_safety",
          section: "HAConfig",
          isRoute: false,
        },
      ],
    },
  { label: "Dictionary", icon: "find_in_page", section: "Dictionary", isRoute: false,
     subToolbarItems: [
      {
          label: "MedDRA",
          icon: "find_in_page",
          section: "MedDRA-info",
          isRoute: false,
        }
     ]
  },
    { label: "Search", icon: "search", section: "search-info", isRoute: false},
    {
      label: "User Management",
      icon: "group",
      section: "user-management",
      isRoute: false,
      subToolbarItems: [
        {
          label: "General Settings",
          icon: "tune",
          section: "admin-config-general",
          isRoute: false,
        },
        {
          label: "Role-Based Access",
          icon: "vpn_key",
          section: "admin-config-rbac",
          isRoute: false,
        },
        {
          label: "Department Mappings",
          icon: "apartment",
          section: "admin-config-dept-mapping",
          isRoute: false,
        },
        {
          label: "Site Access Control",
          icon: "domain",
          section: "admin-config-site-access",
          isRoute: false,
        },
        {
          label: "Study/Trial Assignments",
          icon: "assignment",
          section: "admin-config-study-assign",
          isRoute: false,
        },
        {
          label: "Training Status",
          icon: "school",
          section: "admin-config-training",
          isRoute: false,
        },
        {
          label: "Audit Trail Access",
          icon: "history",
          section: "admin-config-audit-access",
          isRoute: false,
        },
        {
          label: "Inactive User Cleanup",
          icon: "person_off",
          section: "admin-config-inactive-cleanup",
          isRoute: false,
        },
      ],
    },
    {
      label: "Report",
      icon: "bar_chart",
      section: "Report-info",
      isRoute: false,
    },
    {
      label: "Audit Trail",
      icon: "history",
      section: "AuditTrail-info",
      isRoute: false,
    },
    {
      label: "Case Navigator",
      icon: "explore",
      section: "Case Navigator-info",
      isRoute: false,
    },
    {
      label: "Data Mining",
      icon: "analytics",
      section: "jsignal",
      isRoute: true,
    },
    {
      label: "Dashboard",
      icon: "dashboard_customize",
      section: "Dashboard-info",
      isRoute: false,
    },
  ];
  navLinks = [ 
      {
        label: 'Product Safety Strategy Template',
        link: 'trnxBaseComponent?screenType=Dynamic%2FTransactions&tableName=objectmetadata&headerNameHtml=Objects',
        index: 0
      },
      {
        label: 'Product Safety Strategy',
        link: 'stageobject',
        index: 1
      },
       {
        label: 'Review & Approve',
        link: 'mappingconfiguration',
        index: 1
      }
      
    ];
  strategyTemplates = [
    {
      id: "drug",
      label: "Drug Safety Strategy Template 1",
    },
    {
      id: "vaccine",
      label: "Vaccine Safety Strategy Template 2",
      children: [
        { id: "vaccine-create", label: "Create Vaccine Safety Strategy" },
      ],
    },
    {
      id: "device",
      label: "Device Safety Strategy Template 3",
      children: [
        { id: "device-create", label: "Create Device Safety Strategy" },
      ],
    },
    {
      id: "combination",
      label: "Combination Safety Strategy Template 4",
      // no children yet
    },
  ];

  //track the chosen template
  selectedStrategyTemplate: string | null = null;

  /** GROUPED MENU STRUCTURE (new) */
  get menuGroups(): NavGroup[] {
    return [
      {
        label: "Search",
        icon: "search",
        items: this.topNavItems.filter((i) => i.section === "search-info"),
      },
      {
        label: "Configuration",
        icon: "setting",
        items: this.topNavItems.filter(
          (i) => i.section === "Configuration-info"
        ),
      },
      {
        label: "Administration",
        icon: "settings",
        items: this.topNavItems.filter((i) =>
          ["Configuration-info", "user-management", "AuditTrail-info"].includes(
            i.section
          )
        ),
      },
      {
        label: "Dictionary",
        icon: "find_in_page",
        items: this.topNavItems.filter((i) => i.section === "MedDRA-info"),
      },
      {
        label: "Signal Analytics",
        icon: "analytics",
        items: this.topNavItems.filter((i) =>
          ["Report-info", "Case Navigator-info", "jsignal"].includes(i.section)
        ),
      },
    ];
  }
  get configurationItem() {
    return this.topNavItems.find((i) => i.section === "Configuration-info")!;
  }
  get Dashboard() {
    return this.topNavItems.find((i) => i.section === "Dashboard-info")!;
  }
  searchItems!: typeof this.topNavItems;
  adminItems!: typeof this.topNavItems;
  dictItems!: typeof this.topNavItems;
  signalItems!: typeof this.topNavItems;
  configItems!: typeof this.topNavItems;

  products = [
    // {
    //   name: 'Product A',
    //   status: 'Approved',
    //   ibd: '15/03/2021',
    //   dibd: '20/03/2021',
    //   safetyStrategyLink: 'https://example.com/strategy-nivolumab',
    //   safetyTitle: 'Product A Safety Strategy (v3.4)',
    //   genericName: 'nivolumab',
    //   producttype: 'Drug'
    // },
  ];
  productsFiltered = [];
  productsDisplayed = []; // start with full list
  schema: FieldConfig[] = [
    {
      key: "status",
      label: "Regulatory Status",
      type: "select",
      lookupType: "RegulatoryStatus",
    },
    { key: "ibd", label: "IBD Date", type: "date" },
    { key: "genericName", label: "Generic Name", type: "text" },
    {
      key: "producttype",
      label: "Product Type",
      type: "select",
      lookupType: "ProductType",
    },
  ];
  allPossibleFields: FieldConfig[] = [
    ...this.schema,

    // Therapy Info
    {
      key: "moleculeType",
      label: "Molecule Type",
      type: "multiselect",
      options: ["Small Molecules", "Large Molecules", "Biosimilars", "ATMPs"],
    },
    {
      key: "therapeuticCategory",
      label: "Therapeutic Category",
      type: "multiselect",
      options: [
        "Cardiovascular",
        "CNS",
        "Oncology",
        "Endocrinology",
        "Infections Diseases",
        "Respiratory",
        "Gastrointestinal",
        "Immunology & Rheumatology",
        "Hematology",
        "Dermatology",
      ],
    },
    { key: "ibd", label: "IBD", type: "date" },
    { key: "dibd", label: "DIBD", type: "date" },
    { key: "indications", label: "Indications", type: "text" },
    { key: "indicationDesc", label: "Indication Desc", type: "text" },

    // Administration
    { key: "dosageForm", label: "Dosage Form", type: "text" },
    { key: "routeOfAdmin", label: "Route of Admin", type: "text" },
    {
      key: "approvalCountries",
      label: "Approval Countries",
      type: "multiselect",
      options: ["US", "EU", "India", "Japan"],
    }, // update as needed
    { key: "expectedAE", label: "Expected AE List", type: "text" },
    { key: "specialPops", label: "Special Populations", type: "text" },
    { key: "imeList", label: "IME List", type: "text" },
    {
      key: "contraWarnings",
      label: "Contraindication & Warnings",
      type: "text",
    },

    // Literature Info
    { key: "sameinClass", label: "Samein Class", type: "text" },
    {
      key: "modeOfAction",
      label: "Mode of Action",
      type: "select",
      options: ["Gene Therapy", "Cell Therapy"],
    },
    {
      key: "inclusionExclusion",
      label: "Inclusion/Exclusion",
      type: "select",
      options: ["Inclusion", "Exclusion"],
    },
    { key: "reason", label: "Reason", type: "text" },

    // Governance
    {
      key: "dataSourceNames",
      label: "Data Source Names",
      type: "multiselect",
      options: ["Company Safety Data (LSMV, ARGUS)", "FAERS", "EVDAS"],
    },
    { key: "group", label: "Group", type: "text" },
    {
      key: "productLead",
      label: "Product Lead",
      type: "multiselect",
      options: [],
    }, // populate dynamically if needed
    {
      key: "deputyProductLead",
      label: "Deputy Product Lead",
      type: "multiselect",
      options: [],
    },
    { key: "groupHead", label: "Group Head", type: "multiselect", options: [] },
    {
      key: "deputyGroupHead",
      label: "Deputy Group Head",
      type: "multiselect",
      options: [],
    },

    // Device Info
    { key: "udi", label: "UDI", type: "text" },
    { key: "deviceIdentifier", label: "Device Identifier", type: "text" },
    { key: "gmdnCode", label: "GMDN Code", type: "text" },
    { key: "umdcCode", label: "UMDC Code", type: "text" },
    {
      key: "riskClass",
      label: "Risk Class",
      type: "select",
      options: ["Class I", "IIa", "IId", "III (EU MDR)", "I, II, III (FDA)"],
    },
    {
      key: "productCategory",
      label: "Product Category",
      type: "select",
      options: ["Implant", "Diagnostic", "SaMD", "IVD"],
    },
  ];
  previousSection: string = "product-info";
  searchForm!: FormGroup;
  activeFilters: ActiveFilter[] = [];
  advancedSchema: FieldConfig[] = [];
  advancedForm!: FormGroup;
  advancedFilters: ActiveFilter[] = [];
  isSidenavOpen = true;
  showToggle = false;
  activeRouteComponent: string | null = null;
  isRouteView: boolean;
  isHoveringSidebar = false;
  hoverTimeout: any;
  sidenavWidth = 250;
  isResizing = false;
  productSearchText: string = "";

  // listeners for document‐level mouse events
  private mouseMoveListener!: () => void;
  private mouseUpListener!: () => void;
  currentGroup: string | null = null;
  currentSubmenu: any = null;
  defaultToolbarItems: any[] = []; // we'll use this as your default (initial) items
  currentStrategyParent: any = null;
  showProductHeader = true;
  sectionsToHideHeader = [
    "Product Safety Strategy",
    "Configuration-info",
    "Product Safety Strategy Template",
    "Review & Approve",
    "review-info",
    "MedDRA-info",
    
    // Add more as needed
  ];
  sectionsToHideSidenav = [
    "Product Safety Strategy",
    "Configuration-info",
    "Product Safety Strategy Template",
    "Review & Approve",
    "review-info",
     "MedDRA-info",
  ];
  productMeta?: ProductMeta;

  constructor(
    private localStorage: LocalStorageSettingsService,
    private commonService: CommonService,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private router: Router,
    private fb: FormBuilder,
    private renderer: Renderer2,
    private jsignalsService: JsignalService
  ) {}

  ngOnInit(): void {
    this.currentSection =
      localStorage.getItem("currentSection") || "Product Safety Strategy Template";
    if(this.currentSection == "Product Safety Strategy Template"){
    this.selectedTopNavItem = this.topNavItems?.[1];

    }else{
      
    this.selectedTopNavItem = this.topNavItems?.[0];
    }
    //load current section
    
    // Restore section header visibility
    this.showProductHeader = !this.sectionsToHideHeader.includes(
      this.currentSection
    );
    this.isSidenavOpen = !this.sectionsToHideSidenav.includes(
      this.currentSection
    );

    this.backgroundColorScreen = this.localStorage.getSettings("ColorD");
    this.backgroundColorButton = this.localStorage.getSettings("ColorA");
    const group: any = {};
    this.schema.forEach((field) => {
      group[field.key] = field.type === "multiselect" ? [[]] : [""];
    });
    this.searchForm = this.fb.group(group);
    this.advancedForm = this.fb.group({});
    //remove this below line when product selected  from backend
    this.selectedProduct = this.productsFiltered[0];
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const path = event.urlAfterRedirects.split("/")[2]; // 'jsignal', 'product-info', etc.
        this.currentSection = path;
        this.isRouteView = ["jsignal"].includes(path); // Add all route-based names here
      });

    // populate the group‐specific arrays:
    this.searchItems = this.topNavItems
      .filter((item) => item.section === "search-info")
      .map((i) => ({ ...i, isRoute: !!i.isRoute }));

    //Config
    this.configItems = this.topNavItems
      .filter((item) => item.section === "Configuration-info")
      .map((i) => ({ ...i, isRoute: !!i.isRoute }));

    this.adminItems = this.topNavItems
      .filter((item) =>
        ["user-management", "AuditTrail-info"].includes(item.section)
      )
      .map((i) => ({ ...i, isRoute: !!i.isRoute }));

    this.dictItems = this.topNavItems
      .filter((item) => item.section === "MedDRA-info")
      .map((i) => ({ ...i, isRoute: !!i.isRoute }));

    this.signalItems = this.topNavItems
      .filter((item) =>
        ["Report-info", "Case Navigator-info", "jsignal"].includes(item.section)
      )
      .map((i) => ({ ...i, isRoute: !!i.isRoute }));

    this.defaultToolbarItems = [...this.toolbarItems];

    this.loadDynamicOptions(this.allPossibleFields);

    //fetch product name
    /**
   * @author Rahul Vk
   * @Date 14-11-2025
   * @Desc fetch the list of product[{id:,name:}]
   */   
  this.jsignalsService.getProductList().subscribe({
  next: (response: any[]) => {
    try {
      // Validate response type before mapping
      if (!Array.isArray(response)) {
        throw new Error('Invalid response type: expected an array.');
      }

      // Map both id and name safely
      this.products = response.map((item, index) => {
        if (!item || typeof item !== 'object') {
          throw new Error(`Invalid item at index ${index}: ${JSON.stringify(item)}`);
        }

        return {
          id: item.id,
          name: item.name
        } as Product;
      });

      // Initialize your displayed & selected arrays
      this.productsDisplayed = [...this.products];
      this.selectedProduct = this.products[0] || null;

      if (this.selectedProduct) {
        this.loadMeta(this.selectedProduct.name!);
      }
    } catch (error) {
      console.error(' Error while processing product list:', error);
      
    }
  },
  error: (err) => {
    console.error(' API Error while fetching product list:', err);
  },
});



    //  Restore submenu & toolbar
    const savedSubmenuParent = localStorage.getItem("currentSubmenuParent");
    const savedSubmenuItems = localStorage.getItem("currentSubmenuItems");
    const savedGroup = localStorage.getItem("currentGroup");

    if (savedSubmenuParent && savedSubmenuItems) {
      const parentObj = this.topNavItems.find(
        (i) => i.section === savedSubmenuParent
      );
      if (parentObj) {
        this.currentSubmenu = parentObj; // full object with label + icon
        this.toolbarItems = JSON.parse(savedSubmenuItems);
        this.currentGroup = savedGroup;
      }
    } else {
      this.currentSubmenu = null;
      this.toolbarItems = [...this.defaultToolbarItems];
      this.currentGroup = null;
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.updateArrowVisibility(); // bottom
      this.checkTopArrowVisibility(); // added for top
    }, 100);

    setTimeout(() => {
      const withChildren = this.strategyTemplates.filter(
        (t) => t.children?.length
      );
      withChildren.forEach((template, index) => {
        this.menuMap[template.id] = this.childMenus.toArray()[index];
      });
    });
  }

  navigateToRoute() {
    this.showJsignalPage = true;
    this.currentSection = "";
  }

  showSection(section: string): void {
    this.currentSection = section;
  }

  scrollToolbar(direction: "left" | "right") {
    const el = this.toolbarScroll.nativeElement;
    const scrollAmount = 120;

    el.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });

    setTimeout(() => this.updateArrowVisibility(), 300);
  }

  onScroll() {
    this.updateArrowVisibility();
  }

  updateArrowVisibility() {
    const el = this.toolbarScroll.nativeElement;
    this.showLeftArrow = el.scrollLeft > 0;
    this.showRightArrow = el.scrollLeft + el.clientWidth < el.scrollWidth - 1;
  }

  onTopScroll() {
    this.checkTopArrowVisibility();
  }

  scrollTopToolbar(direction: "left" | "right") {
    const scrollAmount = 120;
    const el = this.topToolbarScroll.nativeElement;
    el.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
    setTimeout(() => this.checkTopArrowVisibility(), 300);
  }

  checkTopArrowVisibility() {
    const el = this.topToolbarScroll.nativeElement;
    this.showTopLeftArrow = el.scrollLeft > 0;
    this.showTopRightArrow =
      el.scrollLeft + el.clientWidth < el.scrollWidth - 1;
  }

  isActiveSection(section: string): boolean {
    return this.currentSection === section;
  }

  // === SHOW / HIDE OVERLAY ===
  openSearch() {
    this.previousSection = this.currentSection;
    this.currentSection = "search-info";
  }

  closeSearch() {
    this.currentSection = this.previousSection;
  }

  applyFilters() {
    this.applyAllFilters();

    this.closeSearch();
  }

  // === CHIP REMOVAL ===
  removeFilter(f: ActiveFilter) {
    this.searchForm.get(f.key)!.setValue(Array.isArray(f.value) ? [] : "");
    this.applyAllFilters();
  }

  clearAllFilters() {
    this.searchForm.reset();
    this.activeFilters = [];
    this.productsFiltered = [...this.products];
    this.applyAllFilters();
    this.selectedProduct = this.productsFiltered[0] || null;
  }

  trackByKey(index: number, field: FieldConfig) {
    return field.key;
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  // Utility method to safely parse and normalize dates
  private normalizeDate(input: any): Date | null {
    // Handle native Date
    if (input instanceof Date && !isNaN(input.getTime())) {
      return new Date(input.getFullYear(), input.getMonth(), input.getDate());
    }

    // Handle Moment.js
    if (input && input._isAMomentObject && input.isValid()) {
      return new Date(input.year(), input.month(), input.date());
    }

    // Handle dd/mm/yyyy strings
    if (typeof input === "string") {
      const parts = input.trim().split("/");
      if (parts.length === 3) {
        const [day, month, year] = parts.map(Number);
        if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
          return new Date(year, month - 1, day);
        }
      }

      // Handle ISO yyyy-mm-dd strings
      const isoMatch = input.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (isoMatch) {
        const [_, y, m, d] = isoMatch;
        return new Date(+y, +m - 1, +d);
      }
    }

    return null;
  }

  // Utility to compare two date fields after normalization
  private compareDateField(
    productDate: string | Date,
    filterDate: Date
  ): boolean {
    const d1 = this.normalizeDate(productDate);
    const d2 = this.normalizeDate(filterDate);

    console.log(d1, d2);

    if (!d1 || !d2) return false;

    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
  }

  getFieldType(key: string): string {
    const field = this.schema.find((f) => f.key === key);
    return field ? field.type : "";
  }

  addAdvancedField(field: FieldConfig) {
    // prevent duplicates
    if (this.advancedSchema.find((f) => f.key === field.key)) return;

    this.advancedSchema.push(field);
    // add control (empty initial value)
    this.advancedForm.addControl(
      field.key,
      this.fb.control(field.type === "multiselect" ? [] : "")
    );
  }

  removeAdvancedField(key: string) {
    this.advancedSchema = this.advancedSchema.filter((f) => f.key !== key);
    this.advancedForm.removeControl(key);

    this.productsFiltered = [...this.products]; // restore from original

    this.applyAllFilters();
  }

  applyAdvancedFilters() {
    this.applyAllFilters();

    this.selectedProduct = this.productsFiltered[0] || null;
  }

  getAdvancedFieldByKey(key: string) {
    return this.advancedSchema.find((f) => f.key === key);
  }
  clearAllAdvancedFilters(): void {
    this.advancedSchema = [];
    this.advancedForm.reset();
    this.advancedFilters = [];
    this.productsFiltered = [...this.products];
    this.applyAllFilters();

    if (!this.productsFiltered.includes(this.selectedProduct)) {
      this.selectedProduct = this.productsFiltered[0] || null;
    }
  }

  toggleSidenav() {
    this.isSidenavOpen = !this.isSidenavOpen;

    // Allow DOM to update first before measuring scroll dimensions
    setTimeout(() => {
      this.updateArrowVisibility();
      this.checkTopArrowVisibility();
    }, 200); // Adjust timing if needed
  }

  handleNavClick(item: any, groupLabel?: string): void {
    this.currentSection = item.section;
    localStorage.setItem("currentSection", this.currentSection); // save

    // Check if current section is one that should hide the product header
    this.showProductHeader = !this.sectionsToHideHeader.includes(item.section);

    // 2) Show/hide Sidenav by default
    this.isSidenavOpen = !this.sectionsToHideSidenav.includes(item.section);

    //  // 2) If this item *has* subToolbarItems → open its submenu
    if (item.subToolbarItems) {
      this.currentSubmenu = item;
      this.currentGroup = groupLabel || null;
      // this.topNavItems    = item.subToolbarItems;
      this.toolbarItems = item.subToolbarItems;
      localStorage.setItem("currentSubmenuParent", item.section);
      localStorage.setItem(
        "currentSubmenuItems",
        JSON.stringify(item.subToolbarItems)
      );

      // If parent clicked, check whether we are already inside one of its children
      const isChildActive = item.subToolbarItems.some(
        (child) => child.section === this.currentSection
      );
      console.log(isChildActive);

      // Only auto-select the first child if no child is already active
      if (!isChildActive) {
        const firstChild = item.subToolbarItems[0];
        if (firstChild) {
          this.handleNavClick(firstChild, groupLabel); // recursive call
        }
      }
      return;
    }

    // 3) If we already have a submenu open → clicking a submenu item:
    //    only update section, leave the submenu open
    if (this.currentSubmenu) {
      return;
    }

    // 4) Otherwise it was a plain top‑level click with no submenu:
    //    collapse back to the default toolbar
    if (!item.subToolbarItems) {
      this.currentSubmenu = null;
      this.currentGroup = null;
      this.toolbarItems = [...this.defaultToolbarItems];
      localStorage.removeItem("currentSubmenuParent");
      localStorage.removeItem("currentSubmenuItems");
    }
    this.isRouteView = !!item.isRoute;
  }

  onMouseEnterSidebar() {
    clearTimeout(this.hoverTimeout);
    this.isHoveringSidebar = true;
  }

  onMouseLeaveSidebar() {
    this.hoverTimeout = setTimeout(() => {
      this.isHoveringSidebar = false;
    }, 300); // delay before hiding
  }
  applyAllFilters() {
    const searchValues = this.searchForm.value;
    const advancedValues = this.advancedForm.value;

    // Combine both filter sets
    this.activeFilters = this.schema
      .filter((f) => {
        const v = searchValues[f.key];
        return Array.isArray(v) ? v.length > 0 : !!v;
      })
      .map((f) => ({
        key: f.key,
        label: f.label,
        value: searchValues[f.key],
      }));

    this.advancedFilters = this.advancedSchema
      .filter((f) => {
        const v = advancedValues[f.key];
        return Array.isArray(v) ? v.length > 0 : !!v;
      })
      .map((f) => ({
        key: f.key,
        label: f.label,
        value: advancedValues[f.key],
      }));

    const allFilters = [...this.activeFilters, ...this.advancedFilters];

    this.productsFiltered = this.products.filter((p) =>
      allFilters.every((f) => {
        const val = (p as any)[f.key];
        if (Array.isArray(f.value)) return f.value.includes(val);
        if (this.getFieldType(f.key) === "date")
          return this.compareDateField(val, f.value);
        return String(val).toLowerCase() === String(f.value).toLowerCase();
      })
    );

    // Refresh dropdown search based on new filter result
    this.filterProducts();

    if (!this.productsFiltered.includes(this.selectedProduct)) {
      this.selectedProduct = this.productsFiltered[0] || null;
    }
  }

  //Draggable side bar
  startResize(evt: MouseEvent) {
    evt.preventDefault(); // don’t text‑select
    this.isResizing = true;

    // Attach listeners to document so dragging works outside the bar
    this.mouseMoveListener = this.renderer.listen(
      "document",
      "mousemove",
      (e: MouseEvent) => this.onResize(e)
    );
    this.mouseUpListener = this.renderer.listen("document", "mouseup", () =>
      this.stopResize()
    );
  }

  onResize(e: MouseEvent) {
    if (!this.isResizing) return;
    // Compute new width
    const newWidth = e.clientX;
    this.sidenavWidth = Math.max(150, Math.min(600, newWidth));
  }

  stopResize() {
    this.isResizing = false;
    // clean up
    this.mouseMoveListener();
    this.mouseUpListener();
    this.updateArrowVisibility(); // bottom
    this.checkTopArrowVisibility(); // added for top
  }

  ngOnDestroy() {
    // ensure no leaks
    if (this.mouseMoveListener) this.mouseMoveListener();
    if (this.mouseUpListener) this.mouseUpListener();
  }

  filterProducts() {
    const search = this.productSearchText.toLowerCase().trim();

    const sourceList =
      this.activeFilters.length > 0 || this.advancedFilters.length > 0
        ? this.productsFiltered
        : this.products;

    this.productsDisplayed = sourceList.filter((product) =>
      (product.name || "").toLowerCase().includes(search)
    );
  }

  goBackToMainMenu(): void {
    this.currentGroup = null;
    this.currentSubmenu = null;
    this.toolbarItems = [...this.defaultToolbarItems];
  }

  onSelectStrategyTemplate(id: string): void {
    // Handle final child selection
    this.selectedStrategyTemplate = id;
    this.currentSection = "Product Safety Strategy";
    console.log("Selected:", id);
    this.currentStrategyParent = null; // reset view
  }

  onStrategyParentClick(parent: any, event: Event): void {
    event.stopPropagation();
    this.currentStrategyParent = parent; // Show children
  }

  backToParentList(event: Event): void {
    event.stopPropagation();
    this.currentStrategyParent = null;
  }

  loadDynamicOptions(fields: FieldConfig[]) {
    fields.forEach((field) => {
      if (field.lookupType) {
        this.commonService
          .getlookupVauleByLookUpType(field.lookupType)
          .subscribe((res: any) => {
            const values = res as any[];
            field.options = values.map((v) => v.lookupvalue);
          });
      }
    });
  }

  private parseProduct(raw: any): ProductMeta {
    return {
      id: raw.id ?? raw.product__v ?? null,
      // name__v often null on some records; fallback to generic_name__v
      status: raw.status__v || "",
      dibd: raw.international_birthdate__v ?? null,
      ibd: raw.registration_date__v ?? null,
      // pick whatever makes sense for title/link
      safetyTitle: raw.object_type__v_name__v || "",
      // safetyStrategyLink: raw.link__sys             || ''
    };
  }

  computeInitials(fullName?: string): string {
    const safe = (fullName || "").trim();
    const parts = safe.split(/\s+/).filter((p) => p);
    if (parts.length === 0) return "";
    if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  onProductSelected(prod: Product) {
    this.selectedProduct = prod;
    this.loadMeta(prod.name!);
  }

  /** fetch + map into your interface */
  private loadMeta(name: string) {
    this.productMeta = undefined; // clear old
    this.jsignalsService.getProductMetadata(name).subscribe((arr) => {
      const raw = arr.length ? arr[0] : {};
      this.productMeta = this.mapToMeta(raw);
    });
  }

  /** single place to null-clean & map */
  //need proper json in structure to loop
  private mapToMeta(raw: any): ProductMeta {
    const clean = (v: any): string | null =>
      v == null || (typeof v === "string" && !v.trim()) ? null : v;
    const productName = clean(raw.product__v_name__v) || "";
    return {
      id: clean(raw.id),
      status: clean(raw.status__v),
      dibd: clean(raw.registration_date__v),
      ibd: clean(raw.international_birthdate__v),
      safetyTitle: productName ? `${productName} Safety Strategy` : null,
      // safetyStrategyLink:  clean(raw.link__sys),
      producttype: clean(raw.object_type__v_name__v),
    };
  }

 selectTopNavItem(item: any) {
  this.selectedTopNavItem = item;

  // optional: set default active section when menu changes
  const first = item?.subToolbarItems?.[0];
  if (first?.section) {
    this.currentSection = first.section;
  }

  // optional: if you have routing/module change
  // this.navigate(item.route);
}
}
